// import { matchPath } from 'react-router-dom'; TODO: uncomment after update router to V6
import { useLocation } from './useLocation';

export const useMatchPath = (pathname: string) => {
    const location = useLocation();

    // return !!matchPath(location.pathname, pathname);
    const reg = new RegExp(`^${location.pathname}$`, 'g');
    return reg.test(pathname);
};
